module.exports = __webpack_public_path__ + "img/azure.44110412.png";